export default class FeaturedWork {
	constructor(el) {
		this.$this = $(el);


	}

	init() {
		this.updateSizeImageRightColumn();
		$(window).on('resize', () => {
			setTimeout(() => {
				this.updateSizeImageRightColumn();
			}, 100);
		});
		$(document).on('DOMContentLoaded', () => {
			setTimeout(() => {
				this.updateSizeImageRightColumn();
			}, 100);
		});
	}

	updateSizeImageRightColumn() {

		const $leftColumn = this.$this.find('.gravity-featured-work__left-column .gravity-featured-work__first-row');
		const $imageRightColumn = this.$this.find('.gravity-featured-work__right-column').find('.gravity-featured-work__card-image--large');

		if (window.innerWidth < 768) {
			$imageRightColumn.css('height', '');
			return;
		}
		
		
		if (!$leftColumn.length || !$imageRightColumn.length) {
			return;
		}
		
		const $lastCard = $leftColumn.find('.gravity-featured-work__card').last();
		if (!$lastCard.length) {
			return;
		}
		
		const $lastCardContent = $lastCard.find('.gravity-featured-work__card-content');
		if (!$lastCardContent.length) {
			return;
		}
		
		const leftColumnHeight = $leftColumn.innerHeight();
		const lastCardContentHeight = $lastCardContent.innerHeight();
		const spacing = 24;
		
		const heightImageLeftColumn = leftColumnHeight - lastCardContentHeight - spacing;
		
		if (heightImageLeftColumn >= 0) {
			$imageRightColumn.css('height', heightImageLeftColumn);
		}
	}

}

$('.gravity-featured-work').each((_index, el) => {
	new FeaturedWork(el).init();
});
